import React, { useEffect, useState } from 'react'
import './BrandChosenBanner.scss'
import { BRANDCHOSEN } from '../hooks/config'
import { DeromaLogo, ScheurichLogo } from '../utils/icons'

const BrandChosenBanner = (props) => {
    return (
        <div className="brand-chosen">
              {BRANDCHOSEN == 'fansa' && 
                <div className={`img-${BRANDCHOSEN}`}>
                  <DeromaLogo size={100} />
                </div>
              }
              {BRANDCHOSEN == 'scheurich' && 
                <div className={`img-${BRANDCHOSEN}`}>
                  <ScheurichLogo size={100} />
                </div>
              }

          <hr className='linea'/>
        </div>
    )
}

export default BrandChosenBanner